// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"InfoCardImage_infoCardContainer__hE8-N","imageContainer":"InfoCardImage_imageContainer__5V9Kw","textContainer":"InfoCardImage_textContainer__tShTm"};